import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue'
import baseMessage from '@/views/overseasSales/customerCenter/components/baseMessage.vue'
import { useRoute } from 'vue-router'
import { potentialDetail } from '@/api/overseasSales/customerCenter'

const __default__ = { name: 'DcCosOFbuContractEdit' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()
const data = ref({})
// 获取详情
const fetch = () => {
  if (route.query.cosId) {
    potentialDetail(route.query.cosId).then((res) => {
      if (res.data.business && res.data.business.businessType && res.data.business.businessType?.length > 0) {
        res.data.business.businessTypeSelect = res.data.business.businessType[0]
      }
      if (!res.data.business.contractInfo) {
        res.data.business.contractInfo = { billingTerm: 3475 }
      } else {
        if (res.data.business.contractInfo.paymentType === 3504 || res.data.business.contractInfo.paymentType === 3473) {
          if (!res.data.business.contractInfo.paymentTerm) {
            res.data.business.contractInfo.paymentTerm = '10'
          }
        }
      }
      if (res.data.business.contractInfo && !res.data.business.contractInfo.billingTerm) {
        res.data.business.contractInfo.billingTerm = 3475
      }
      data.value = res.data
    })
  }
}
const permissionBasic = {
  save: 'ofbu_contract_edit_btn',
  editCode: 'ofbu_contract_edit_name_or_code_btn'
}
onMounted(() => {
  fetch()
})

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(baseMessage, {
            perfect: true,
            disabled: false,
            permissionPage: permissionBasic,
            data: data.value,
            type: "contract"
          }, null, 8, ["data"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})